import { CompRef, DocumentServicesObject } from '@wix/document-services-types';
import type { EditorPointer } from '@wix/editor-platform-feature-store';
import { EditorPointerServiceAPI } from '@wix/editor-platform-feature-store';

import { getCustomEditActions } from './customActions';
import { getNativeEditActions } from './nativeActions';
import { getSystemActions } from './systemActions';
import { PlatformContext } from './types';
import {
  IEditorPlatformPackagesBridge,
  PlatformApiMethods,
} from '@wix/editor-platform-host-integration-apis';
import { ComponentsService } from '@wix/editor-platform-manifest-services';

export function initEditActionsServices(
  documentServicesAPI: DocumentServicesObject,
  componentsAPI: ComponentsService,
  hostAPI: PlatformApiMethods,
  isBuilderServicesEnabled: boolean,
  editorPlatformPackagesBridge: Partial<IEditorPlatformPackagesBridge>,
  editorPointerAPI?: EditorPointerServiceAPI,
) {
  if (!isBuilderServicesEnabled || !editorPointerAPI) {
    return {
      generateEditActions: () => ({
        nativeActions: [],
        customActions: [],
        systemActions: [],
      }),
    };
  }

  function generateEditActions(
    editorPointer: EditorPointer<CompRef>,
    tags?: string[],
  ) {
    const platformContext: PlatformContext = {
      editorPointer,
      editorPointerAPI: editorPointerAPI!,
      documentServicesAPI,
      componentsAPI,
      hostAPI,
      editorPlatformPackagesBridge,
    };

    return {
      nativeActions: getNativeEditActions(platformContext, tags),
      customActions: getCustomEditActions(platformContext, tags),
      systemActions: getSystemActions(platformContext, tags),
    };
  }

  return {
    generateEditActions,
  };
}
